import { get, post, put } from 'api/request';
import urls from 'configs/urls';
import appModeService from 'services/AppModeService';

export const getInsuranceCompany = () =>
  get(null, false, urls.healthPlansApi.getInsuranceCompany, null);

export const addHealthPlan = payload => {
  const companyKey = appModeService.getCompanyKey();
  const data = { ...payload.data };
  
  if (appModeService.isEmbedded && companyKey) {
    data.BeneficiaryCompanyKey = companyKey;
  }
  
  return post(null, false, urls.healthPlansApi.HealthPlans, data);
};

export const editHealthPlan = payload =>
  put(null, false, `${urls.healthPlansApi.HealthPlans}/${payload.id}`, payload.data);

export const getHealthPlans = queryString => {
  const companyKey = appModeService.getCompanyKey();
  let finalQueryString = queryString;
  
  if (appModeService.isEmbedded && companyKey) {
    const prefix = finalQueryString ? '&' : '';
    finalQueryString += `${prefix}BeneficiaryCompanyKey=${companyKey}`;
  }
  
  return get(null, false, `${urls.healthPlansApi.HealthPlans}?${finalQueryString}`, null);
};
